import { render, staticRenderFns } from "./JSelectBaseBizComponentModal.vue?vue&type=template&id=42aa54a1&scoped=true"
import script from "./JSelectBaseBizComponentModal.vue?vue&type=script&lang=js"
export * from "./JSelectBaseBizComponentModal.vue?vue&type=script&lang=js"
import style0 from "./JSelectBaseBizComponentModal.vue?vue&type=style&index=0&id=42aa54a1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aa54a1",
  null
  
)

export default component.exports